/**
 * Lifecycle extension points (BAdI pattern) where a {@code DunningTypeExit}
 * can hook into the dunning process.
 *
 * Mirrors backend enum {@code com.mvs.backend.bd.enums.BdDunningExitPoint}.
 * Ordinal mapping (MUST match the backend enum):
 *    0 = BEFORE_DUNNING_START
 *    1 = AFTER_DUNNING_START
 *    2 = BEFORE_LEVEL_ADVANCE
 *    3 = AFTER_LEVEL_ADVANCE
 *    4 = BEFORE_ACTION_EXECUTE
 *    5 = AFTER_ACTION_EXECUTE
 *    6 = ON_BALANCE_CHANGE
 *    7 = ON_DUNNING_COMPLETE
 *    8 = ON_PLAN_CREATED
 *    9 = ON_PLAN_BREACH
 *
 * @ticket bd-dunningtype-overview
 */
export enum BdDunningExitPoint {
    BEFORE_DUNNING_START,
    AFTER_DUNNING_START,
    BEFORE_LEVEL_ADVANCE,
    AFTER_LEVEL_ADVANCE,
    BEFORE_ACTION_EXECUTE,
    AFTER_ACTION_EXECUTE,
    ON_BALANCE_CHANGE,
    ON_DUNNING_COMPLETE,
    ON_PLAN_CREATED,
    ON_PLAN_BREACH
}

/**
 * German UI labels for BdDunningExitPoint values.
 */
export const BD_DUNNING_EXIT_POINT_LABELS: Record<BdDunningExitPoint, string> = {
    [BdDunningExitPoint.BEFORE_DUNNING_START]: 'Vor Mahnungsstart',
    [BdDunningExitPoint.AFTER_DUNNING_START]: 'Nach Mahnungsstart',
    [BdDunningExitPoint.BEFORE_LEVEL_ADVANCE]: 'Vor Stufenwechsel',
    [BdDunningExitPoint.AFTER_LEVEL_ADVANCE]: 'Nach Stufenwechsel',
    [BdDunningExitPoint.BEFORE_ACTION_EXECUTE]: 'Vor Aktionsausführung',
    [BdDunningExitPoint.AFTER_ACTION_EXECUTE]: 'Nach Aktionsausführung',
    [BdDunningExitPoint.ON_BALANCE_CHANGE]: 'Bei Saldoänderung',
    [BdDunningExitPoint.ON_DUNNING_COMPLETE]: 'Bei Mahnungsabschluss',
    [BdDunningExitPoint.ON_PLAN_CREATED]: 'Bei Plan-Erstellung',
    [BdDunningExitPoint.ON_PLAN_BREACH]: 'Bei Plan-Bruch'
};
